import React from "react";
import "../../App.css";

const Apropos = () => {
  return (
    <section
      id="apropos"
      className="min-h-screen bg-gray-100 flex flex-col justify-center items-center py-12"
    >
      <h2 className="text-4xl md:text-5xl font-bold text-[#03224C] mb-8 md:mb-12 text-center">
        À propos de moi
      </h2>

      {/* Contenu en deux colonnes */}
      <div className="flex flex-col md:flex-row items-center md:items-start w-11/12 sm:w-4/5 md:w-3/4 lg:w-2/3 mx-auto">
        <div className="md:w-1/2 mb-8 md:mb-0 md:mr-12">
          <img
            src="/images/moi2.jpg"
            alt="À propos de moi"
            className="rounded-full w-60 h-60 sm:w-72 sm:h-72 md:w-80 md:h-80 object-cover mx-auto shadow-lg" // Ajustement des dimensions de l'image
          />
        </div>

        <div className="md:w-1/2 text-black text-base sm:text-lg md:text-lg leading-relaxed animate__animated animate__zoomIn animate__delay-1s">
          <p className="mb-4">
            Je suis Reich Bella, développeur Web Full Stack, passionné par la
            création d'expériences web et de solutions innovantes. Mon expertise
            couvre à la fois le front-end et le back-end, me permettant de
            concevoir des solutions complètes, intuitives et sécurisées.
          </p>
          <p>
            J'apprécie particulièrement travailler avec des technologies
            modernes pour développer des applications interactives et
            dynamiques. Toujours en quête de nouveaux défis, je suis motivé à
            améliorer constamment mes compétences et à explorer de nouvelles
            technologies pour rester à la pointe de l'innovation.
          </p>

          <div className="mt-6 text-center md:text-left">
            <a
              href="/cv/mycv.pdf"
              download
              className="bg-[#03224C] text-white px-6 py-3 rounded-md shadow-md hover:bg-blue-700 transition-colors duration-300 inline-block"
            >
              Télécharger mon CV
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Apropos;
